import { FC } from 'react';
import { ErrorBox } from '~/components/ui/error';
import { Page } from '~/components/ui/page';

export const ErrorScreen: FC<Props> = ({ title, message, refetch, cancel }) => {
  return (
    <Page innerWrapperSx={{ width: { xs: '100%', sm: '800px' } }}>
      <ErrorBox title={title} message={message} retry={refetch} cancel={cancel} />
    </Page>
  );
};

interface Props {
  title: string;
  message: string;
  refetch?: () => void;
  cancel?: () => void;
}
